import { getJSON } from '@/services/httpService';

export const getConfigs = () => getJSON(`/configurations/`);
export const getConfig = (configurationName) =>
  getJSON(`/configurations/${configurationName}`);

export const searchConfigs = (filters) =>
  getJSON(`/configurations/search?${filters.join('&')}`);
